import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import { useProviderStatementBalanceEmailTemplateProvider } from '../ProviderStatementBalanceEmailTemplate.Hooks';

export default function ProviderStatementBalanceEmailTemplateDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useProviderStatementBalanceEmailTemplateProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.name}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
